import { Button, Input, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "../SubadminForms.css";
import axios from "axios";
import React, { useState } from "react";
import { Error, Success } from "../../../commons/Messages/Messages";
import SelectComp from "../../../commons/Select/Select";

import { useTranslation } from "react-i18next";
const AddDesignation = ({ updateParent, departments }) => {
  const { t } = useTranslation("dashboard");
  const [formData, setFormData] = useState({
    title: "",
    departmentId: ""
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChange = (key, val) => {
    setFormData({
      ...formData,
      [key]: val
    });
  };

  const onSubmit = async e => {
    e.preventDefault();
    await axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/designations/add`, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        if (err?.response && err?.response?.data && err?.response?.data?.errors) {
          const validationErrors = err?.response?.data?.errors;
          const errorMessage = Object.values(validationErrors)
            ?.map(err => `${err?.path} is ${err?.kind}.`)
            .join("\n");
          Error(errorMessage);
        } else if (err?.response?.data?.keyPattern) {
          Error(Object.keys(err?.response?.data?.keyPattern) + " already exists");
        } else {
          Error(err.message);
        }
      });
  };

  return (
    <div className="subadmin-form">
      <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
        {t("Add Designation")}
      </Button>
      <Modal
        destroyOnClose
        title={t("Add Designations")}
        width={520}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button key="save" type="primary" htmlType="submit" form="subadmin-add-designation">
            {t("Save")}
          </Button>
        ]}
      >
        <form id="subadmin-add-designation" className="subadmin-form__body" onSubmit={onSubmit}>
          <div className="subadmin-form__field">
            <label>{t("Department")}</label>
            <SelectComp
              handleChange={val => handleChange("departmentId", val)}
              options={departments}
            />
          </div>
          <div className="subadmin-form__field">
            <label htmlFor="subadmin-add-designation-title">{t("Designation Title")}</label>
            <Input
              id="subadmin-add-designation-title"
              onChange={e => handleChange("title", e.target.value)}
              autoComplete="off"
            />
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default AddDesignation;
